import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgAhaBhaTonerSolutionGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M25.623 24.8h3.836v1.3h-3.836l2.656 2.7-.886.9-2.655-2.7v3.8h-1.18V27l-2.656 2.7-.886-.9 2.656-2.7h-3.836v-1.3h3.836l-2.655-2.7.885-.9 2.655 2.7v-3.8h1.18v3.8l2.657-2.7.885.9-2.656 2.7Z",
    fill: "currentColor"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.705 18.2c-.098-.8-.59-1.5-1.377-1.9l-3.738-2v-3.5s.099 0 .099-.1c1.082-.7 1.18-1.3 1.082-1.7-.099-.4-.492-.9-1.77-1-.788 0-1.673.1-2.657.3-1.672.5-3.54 1.4-3.639 2.5v3.3l-4.033 2.2c-.688.4-1.278 1.1-1.377 1.9-.492 3.5-.59 15 2.164 20.6l.099.1c.688.8 3.934 1.1 6.688 1.1.738 0 1.442-.033 2.039-.061.438-.021.817-.039 1.109-.039 2.36-.2 2.852-.7 3.147-1.1 2.754-5.6 2.656-17.2 2.164-20.6ZM21.984 12c.088 0 .157.02.232.042.09.027.189.056.342.058h.213c.787 0 1.573-.1 2.459-.3.196-.05.393-.125.59-.2.197-.075.393-.15.59-.2V14h-4.525v-2c.033.017.066.03.099.042V12Zm2.95-1.4c-1.475.3-2.459.3-2.852.2l.295-.3c.394-.3 1.18-.7 2.263-1 1.475-.4 2.459-.3 2.852-.2-.098.1-.393.3-.689.5-.413.252-.896.434-1.506.663l-.363.137Zm-8.459 7.8c.099-.4.295-.8.689-1l4.131-2.2h5.41l4.131 2.2c.394.2.59.6.689 1 .491 3.6.393 14.8-2.066 19.8-.885.8-9.836.8-10.918 0-2.557-5.2-2.557-16.2-2.066-19.8Z",
    fill: "currentColor"
  }));
}

export { SvgAhaBhaTonerSolutionGlyph as default };
